"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const Article_1 = require("../Article");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_product_models_1 = require("@igus/echain-product-models");
class Link extends Article_1.Article {
    constructor() {
        super(...arguments);
        this.className = 'Link';
    }
    static fromScratch(linkType) {
        return new Link({
            ArticleType: echain_product_models_1.ArticleType.link,
            LinkType: linkType,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
        });
    }
    static fromJson(args, cloneStrategy = 'deep') {
        const link = Link.fromScratch(echain_shared_articles_1.LinkType.StandardLink);
        link.fromJson(args, cloneStrategy);
        return link;
    }
    static fromModel(model) {
        const link = Link.fromScratch(echain_shared_articles_1.LinkType.StandardLink);
        // patch the given model ref into the Link model
        Object.assign(link.model, model);
        // patch the Link model into the given model ref
        Object.assign(model, link.model);
        // set the Link model to the given model ref
        link.model = model;
        return link;
    }
    fromJson(json, cloneStrategy = 'deep', deepCloneSanitizeOptions = { removeNully: true }, doNotOverwritePropertyKeys = []) {
        super.fromJson(json, cloneStrategy, deepCloneSanitizeOptions, doNotOverwritePropertyKeys);
    }
    clone() {
        return this._clone(Link.fromScratch(echain_shared_articles_1.LinkType.StandardLink));
    }
    duplicate() {
        return this._duplicate();
    }
}
exports.Link = Link;
//# sourceMappingURL=Link.js.map